import {
  useProjectQuery,
  Project,
} from "@/features/projects/graphql/generated";

export const useProject = (positionId: number, disableCache?: boolean) => {
  const { data, loading, error } = useProjectQuery({
    variables: { positionId },
    skip: !positionId,
    fetchPolicy: disableCache ? "network-only" : "cache-and-network",
  });

  const position = data?.project || ({} as Project);

  return {
    ...position,
    loading,
  };
};
